export default __webpack_public_path__ + "locales/app.kk.json";